import { cn } from "@/libs/cn";
import { getContrastColor } from "@/libs/color";
import { cva } from "class-variance-authority";
import { splitProps } from "solid-js";

export const badgeVariants = cva(
  "shadow-none border-transparent inline-flex items-center px-2 py-0.5 text-2xs font-semibold transition-shadow focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-ring",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground",
        success:
          "bg-green-500 text-white",
        info:
          "bg-sky-500 text-white",
        danger:
          "bg-red-500 text-white",
        warning:
          "bg-yellow-500 text-white",
        dark:
          "bg-gray-900 text-white dark:bg-white dark:text-gray-900",
        white:
          "bg-white shadow-sm border border-gray-200 text-gray-900 dark:bg-gray-900 dark:text-white",
        custom:
          "bg-(--badge-color) text-(--badge-text-color)"
      },
      shape: {
        default: "rounded-sm",
        rounded: "rounded-full",
        square: "rounded-none"
      },
      size: {
        default: "text-xs",
        xs: "text-3xs py-0",
        sm: "text-2xs",
        md: "text-sm",
        lg: "text-md"
      },
    },
    defaultVariants: {
      variant: "default",
      shape: "default",
      size: "default",
    },
  },
);

export const Badge = (props) => {

  const [local, rest] = splitProps(props, ["class", "shape", "variant", "size", "color"]);

  return (
    <div
      style={{ "--badge-color": local.color, "--badge-text-color": getContrastColor(local.color) }}
      class={cn(
      badgeVariants({
        variant: local.variant,
        shape: local.shape,
        size: local.size
      }),
      local.class,
    )} {...rest} />
  );
}
